export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  container: "site-nav",
  logo: "site-nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkPortfolio: "nav-link-portfolio",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  scrollIndicator: "hero-scroll-indicator",
};

export const SERVICES = {
  section: "services-section",
  card: (key) => `service-card-${key}`,
};

export const PORTFOLIO = {
  section: "portfolio-section",
  card: (key) => `portfolio-card-${key}`,
};

export const ABOUT = {
  section: "about-section",
  stat: (key) => `about-stat-${key}`,
};

export const CLIENTS = {
  section: "clients-section",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputCompany: "contact-input-company",
  inputSubject: "contact-input-subject",
  inputMessage: "contact-input-message",
  submitBtn: "contact-submit-btn",
  successMsg: "contact-success-msg",
  errorMsg: "contact-error-msg",
  emailLink: "contact-email-link",
  mapLink: "contact-map-link",
};

export const FOOTER = {
  section: "site-footer",
};

export const PORTFOLIO_MODAL = {
  root: "portfolio-modal",
  close: "portfolio-modal-close",
  prev: "portfolio-modal-prev",
  next: "portfolio-modal-next",
  title: "portfolio-modal-title",
  image: "portfolio-modal-image",
  description: "portfolio-modal-description",
  counter: "portfolio-modal-counter",
};

export const GIS_PAGE = {
  root: "gis-page",
  back: "gis-page-back",
  ctaContact: "gis-page-cta-contact",
  ctaPortfolio: "gis-page-cta-portfolio",
};

export const SERVICE_LINK = {
  gisPage: "service-gis-link-page",
  gisPortfolio: "service-gis-link-portfolio",
};
